import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import {
  Icon,
  Intent,
  InputGroup,
  Hotkey,
  Hotkeys,
  HotkeysTarget,
} from '@blueprintjs/core';
import styled from 'styled-components';
import * as _ from 'lodash';

import NganhNgheSelect from 'components/elements/select-nganh-nghe';
import KhuCumCongNghiepSelect from 'components/elements/select-khu-cum-cong-nghiep';
import SelectTinhTrangHoatDong from 'components/elements/select-tinh-trang-hoat-dong';
import SelectTinhTrangHoSo from 'components/elements/select-tinh-trang-ho-so';

import Clearfix from 'components/elements/clearfix';
import { IconNames } from '@blueprintjs/icons';
import { SELECT_ITEM_DEFAULT } from 'config';
import { VungCapNuocData } from 'constants/custom-data';
import { COLOR } from 'config';
import { IS_ENTERPRISE } from 'config';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

@HotkeysTarget
export default class SearchContainer extends React.Component {
  static propTypes = {
    handelSubmitSearch: PropTypes.func,
    form: PropTypes.object.isRequired,
    isDisable_FacilityParent: PropTypes.bool,
    placeholderSearch: PropTypes.string,
    moduleName: PropTypes.string
  };

  state = {
    VungCapNuoc_4: [...VungCapNuocData],
  };

  submit = () => {
    this.props.form.validateFields((error, value) => {
      if (error) return;
      value.district = _.get(value.district, 'value');
      value.Commune = _.get(value.Commune, 'value');
      value.sector = _.get(value.sector, 'value');
      value.authority = _.get(value.authority, 'value');
      value.bentrongngoaiSelect = _.get(value.bentrongngoaiSelect, 'value');
      value.industrialArea = _.get(value.industrialArea, 'value');
      value.ReceviedSource_1 = _.get(value.ReceviedSource_1, 'value');
      value.ReceviedSource_2 = _.get(value.ReceviedSource_2, 'value');
      value.facilityParent = _.get(value.facilityParent, 'value');
      value.businessActivity = _.get(value.businessActivity, 'value');
      value.status = _.get(value.status, 'value');

      if (this.props.handelSubmitSearch) this.props.handelSubmitSearch(value);
    });
  };

  renderHotkeys() {
    return (
      <Hotkeys>
        <Hotkey
          //global={true}
          allowInInput={true}
          combo='enter'
          label='Be awesome all the time'
          onKeyDown={this.submit}
        />
      </Hotkeys>
    );
  }

  render() {
    const {
      getFieldDecorator,
      setFieldsValue,
    } = this.props.form;

    const isFacility = this.props.moduleName === 'facility'
    const defaultSpanCol = IS_ENTERPRISE && isFacility ? 3 : 4

    return (
      <div>
        <Row>
          <Col>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span>Tìm kiếm</span>
              <Clearfix width={8} />
              <div style={{ flex: 1 }}>
                {getFieldDecorator('search', {
                  initialValue: '',
                })(
                  <InputGroup
                    placeholder={
                      this.props.placeholderSearch
                        ? this.props.placeholderSearch
                        : `Tên cơ sở/dự án ${IS_ENTERPRISE ? '' : 'hoặc Tên doanh nghiệp '}hoặc Mã số thuế`
                    }
                  />
                )}
              </div>
              <Clearfix width={8} />
              <Icon
                icon={IconNames.SEARCH}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.SUCCESS}
                style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                onClick={this.submit}
              />
            </div>
          </Col>
        </Row>

        <Clearfix height={8} />

        <Row>
          <Col xs={defaultSpanCol}>
            <KhuCumCongNghiepSelect
              onChangeIsKhuCongNghiep={(val) => {
                setFieldsValue({
                  industrialArea: SELECT_ITEM_DEFAULT,
                });
              }}
              fieldForm={{
                form: this.props.form,
                name: 'industrialArea',
              }}
            />
          </Col>

          <Col xs={defaultSpanCol}>
            <NganhNgheSelect
              fieldForm={{
                form: this.props.form,
                name: 'sector',
              }}
            />
          </Col>

          <Col xs={defaultSpanCol}>
            <Container>
              <span>Tình trạng hoạt động</span>
              <Clearfix width={8} />
              <div style={{ flex: 1 }}>
                <SelectTinhTrangHoatDong
                  hideLabel
                  fieldForm={{
                    form: this.props.form,
                    name: 'businessActivity',
                  }}
                />
              </div>
            </Container>
          </Col>

          {
            IS_ENTERPRISE && isFacility && 
              <Col xs={3}>
                <Container>
                  <span>Tình trạng hồ sơ</span>
                  <Clearfix width={8} />
                  <div style={{ flex: 1 }}>
                    <SelectTinhTrangHoSo
                      hideLabel
                      fieldForm={{
                        form: this.props.form,
                        name: 'status',
                      }}
                    />
                  </div>
                </Container>
              </Col>
          }
        </Row>

        <Clearfix height={8} />

    

        {this.props.expand}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/BaseContainer/SearchContainer.js